import { useCommerceFromStore } from '@store/actions/commerce';

/**
 * Fecha de corte: Agosto 1, 2025
 * Comercios creados desde esta fecha en adelante verán la página de Setup
 */
const SETUP_CUTOFF_DATE = new Date('2025-08-01').getTime();

/**
 * Hook para determinar si el comercio debe tener acceso a la página de Setup
 *
 * Lógica: Mostrar Setup a todos los comercios creados desde Agosto 2025 en adelante
 *
 * Nota: fecha_registro_timestamp está en SEGUNDOS, pero JavaScript Date usa MILISEGUNDOS,
 * por lo que multiplicamos por 1000 para la comparación correcta.
 *
 * @returns {boolean} true si el comercio debe ver la página de Setup
 *
 * @example
 * ```tsx
 * const shouldShowSetup = useShouldShowSetup();
 *
 * if (!shouldShowSetup) {
 *   navigate('/');
 * }
 * ```
 */
export const useShouldShowSetup = (): boolean => {
  const commerce = useCommerceFromStore();

  // Si no hay fecha de registro, asumir que es un comercio antiguo
  if (!commerce.fecha_registro_timestamp) {
    return false;
  }

  // Convertir timestamp de segundos a milisegundos antes de comparar
  const fechaRegistroMs = commerce.fecha_registro_timestamp * 1000;

  // Mostrar Setup a comercios creados desde Agosto 2025 en adelante
  return fechaRegistroMs >= SETUP_CUTOFF_DATE;
};
